import axios from 'axios';
import config from '../../../config';
import { BadgeInformation } from '../types';
import {
  BadRequestException,
  ExpiryAlreadyResetException,
  InternalErrorException,
  NotFoundException,
  UnprocessableEntityException,
} from './error';

const attendeesApi: string = config.apiEndpoints.attendees;
const attendeesEndpoint: string = `${attendeesApi}/attendees`;

export interface AttendeesApi {
  getBadgeInformation: (attendeeId: string) => Promise<BadgeInformation>;
}

const getBadgeInformation = async (
  attendeeId: string,
): Promise<BadgeInformation> => {
  const response = await axios.get(
    `${attendeesEndpoint}/badge/${config.conference}/${attendeeId}`,
  );
  return response.data;
};

export class Attendees implements AttendeesApi {
  public async getBadgeInformation(
    attendeeId: string,
  ): Promise<BadgeInformation> {
    return getBadgeInformation(attendeeId).catch((e) => {
      console.error(e);
      if (e.message.endsWith('404')) {
        throw new NotFoundException();
      } else if (e.message.endsWith('400')) {
        throw new BadRequestException();
      } else if (e.message.endsWith('422')) {
        throw new UnprocessableEntityException();
      } else if (e.message.endsWith('409')) {
        throw new ExpiryAlreadyResetException();
      } else throw new InternalErrorException();
    });
  }
}
